import React, { useEffect, Fragment } from "react";
import Header from "../../components/layout/Header";
import Miniaturas from "../../components/Miniaturas";

import {
  getSubCategoriasR as getSubCats,
  getArticulosR as getArts,
  jsonDeserialize,
} from "../../API/request";
import Loading from "../../components/Loading";
import { useDispatch } from "react-redux";
import { fetchArts } from "../../redux/slices/articulosSlice";

const Collection = (props) => {
  const showPrice = process.env.REACT_APP_SHOW_PRICE === "false" ? false : true;
  const [showLoading, setShowLoading] = React.useState(true);
  const [listadoCategorias, setListadoCategorias] = React.useState(null);
  const [categoriaActual, setCategoriaActual] = React.useState(null);

  // const [listadoArticulos, setListadoArticulos] = React.useState(null);
  const [listadoArticulosGenericos, setListadoArticulosGenericos] =
    React.useState(null);
  const [listadoArticulosDestacados, setListadoArticulosDestacados] =
    React.useState(null);

  const collectionName = props.match.params.subCategory;
  const idCategoria = props.match.params.category;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchArts());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);

    setShowLoading(true);
    // setListadoArticulos(null);
    setListadoArticulosGenericos(null);
    setListadoArticulosDestacados(null);
    setCategoriaActual(null);

    getArts(collectionName)
      .then((responseArticulos) => {
        let arts = jsonDeserialize(responseArticulos.data.data);

        setCategoriaActual(arts.categoria);
        document.title = "Collection - " + arts.categoria;

        let articulosGenericos = arts.articulos.data.filter(
          (item) => item.destacado === "False"
        ).sort(function (a, b) {
          return a.nombre.localeCompare(b.nombre, 'en', { numeric: true })
        });
        let articulosDestacados = arts.articulos.data.filter(
          (item) => item.destacado === "True"
        ).sort(function (a, b) {
          return a.nombre.localeCompare(b.nombre, 'en', { numeric: true })
        });

        setListadoArticulosGenericos(
          articulosGenericos.length > 0 ? articulosGenericos : null
        );
        setListadoArticulosDestacados(
          articulosDestacados.length > 0 ? articulosDestacados : null
        );

        getSubCats(idCategoria)
          .then((responseCategorias) => {
            let cats = jsonDeserialize(responseCategorias.data.data).data;

            setListadoCategorias(cats);
            setShowLoading(false);

            window.scrollTo(0, 0);
          })
          .catch((errorMessageGetMantenimiento) => {
            console.log("ERORR - En la petición");
          });
      })
      .catch((errorMessageGetMantenimiento) => {
        console.log("ERORR - En la petición");
      });
  }, [
    collectionName,
    setListadoCategorias,
    // setListadoArticulos,
    setCategoriaActual,
    setListadoArticulosGenericos,
    setListadoArticulosDestacados,
    idCategoria,
  ]);

  return (
    <Fragment>
      {showLoading ? (
        <Loading />
      ) : (
        <>
          {/* <Header
            category={collectionName}
            menuType={false}
            listado={listadoCategorias}
            actual={categoriaActual}
          /> //Header extended old */}

          <Header
            showHeader
            showBtnBack
            menuType={false}
            listado={listadoCategorias}
            actual={categoriaActual}
          />
          <div className="content secondary">
            {(listadoArticulosDestacados !== null) && (
              <Miniaturas
                title="Exclusivos"
                listArticulos={[...listadoArticulosDestacados]}
                showPrice={showPrice}
                catSelect={idCategoria}
              />
            )}
            {(listadoArticulosGenericos !== null) && (
              <Miniaturas
                title="Accesorios disponibles para todos los modelos"
                listArticulos={[...listadoArticulosGenericos]}
                showPrice={showPrice}
                catSelect={idCategoria}
              />
            )}
            
            <div className="container">
              <div className="row legal--txt mb-0 pb-5">
                <p className="mb-0 pb-5">
                  Las imágenes son únicamente de referencia, algunas versiones pueden cambiar según el modelo del vehículo. Para mayor información sobre versiones, accesorios, precios, promociones y disponibilidad de nuestros productos se recomienda acudir a tu Distribuidor Autorizado Audi dentro de la República Mexicana.
                </p>
              </div>
            </div>

          </div>
        </>
      )}
    </Fragment>
  );
};

export default Collection;
